import type { SVGProps } from "react";

export function IconPurpleUmbrella(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 50.3333C16 51.3838 16.2069 52.4241 16.609 53.3947C17.011 54.3653 17.6003 55.2472 18.3431 55.9901C19.086 56.733 19.9679 57.3222 20.9385 57.7243C21.9091 58.1263 22.9494 58.3333 24 58.3333C25.0506 58.3333 26.0909 58.1263 27.0615 57.7243C28.0321 57.3222 28.914 56.733 29.6569 55.9901C30.3997 55.2472 30.989 54.3653 31.391 53.3947C31.7931 52.4241 32 51.3838 32 50.3333L32 32.75"
        stroke="#2A222A"
        strokeWidth="1.5"
      />
      <mask
        id="mask0_9193_46446"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="52"
        height="27"
      >
        <path
          d="M32 7C57 7 57 32 57 32H7C7 32 6.99995 7 32 7Z"
          fill="#F9832F"
          stroke="#F9832F"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_9193_46446)">
        <path
          d="M32 7C57 7 57 32 57 32H7C7 32 6.99995 7 32 7Z"
          fill="#2E2E2E"
          stroke="#2E2E2E"
          strokeWidth="1.5"
        />
        <path
          d="M43 32C43 25.3696 41.8411 19.0107 39.7782 14.3223C37.7153 9.63392 34.9174 7 32 7C29.0826 7 26.2847 9.63392 24.2218 14.3223C22.1589 19.0107 21 25.3696 21 32"
          stroke="#2A222A"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          d="M7 24C23.3158 24 56.1579 24 57 24"
          stroke="#2A222A"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
      <path
        d="M32 7V4"
        stroke="#2A222A"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
